// extracted by mini-css-extract-plugin
export default {"container":"game_container__S9LGr","game":"game_game__cpiBR","gameHistory":"game_gameHistory__Rd9cM","historyList":"game_historyList__1v55U","historyBtn":"game_historyBtn__FjaX6"};